import clsx from 'clsx';
import { useContext } from 'react';
import { I18nContext } from 'src/stores/I18n';
import styles from '../index.module.scss';

export const AbuseNotice = () => {
  const localeResources = useContext(I18nContext);
  return (
    <div className={styles.wrap}>
      <div className={clsx(styles.mt5, styles.bold)}>■{localeResources.products.medicine.abused.title}</div>
      <div className={styles.description}>{localeResources.products.medicine.abused.desc}</div>
      <div className={clsx(styles.mt10, styles.bold)}>{localeResources.products.medicine.abused.ingredient.title}</div>
      <div className={styles.description}>{localeResources.products.medicine.abused.ingredient.desc}</div>

      <div className={clsx(styles.listContainer, styles.mt5)}>
        <p className={clsx(styles.mt10, styles.bold)}>{localeResources.products.medicine.abused.confirm.title}</p>
        <p className={styles.description}>{localeResources.products.medicine.abused.confirm.least18years}</p>
        <p className={styles.description}>{localeResources.products.medicine.abused.confirm.notBoughtAnyMedicine}</p>
        <p className={styles.description}>{localeResources.products.medicine.abused.confirm.notMadeConsecutive}</p>
      </div>
    </div>
  );
};
